import { AdsMagneto } from "@amzn/ads-magneto-typescript-client";
import {
    getCredentialsFromCacheOrCognito,
    APPENV,
} from "@amzn/midway-cognito-type-script-provider";
import { useStore } from "zustand";

import { apiClientsStore } from "../../store/apiClients";
import { authStore } from "../../store/auth";

export class AdsMagnetoIHubClient extends AdsMagneto {}
export async function getMagnetoApi(): Promise<AdsMagnetoIHubClient> {
    try {
        const {
            settings: { magnetoPoolId, region, magnetoApiEndpoint },
        } = authStore.getState();

        if (!magnetoApiEndpoint) {
            throw new Error("magneto endpoint not yet defined");
        }

        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentialsFromCacheOrCognito({
                region,
                identityPoolId: magnetoPoolId,
                clientId: window.location.host,
                redirectUri: window.location.href,
            });

        return new AdsMagnetoIHubClient({
            endpoint: `${
                APPENV.mock_server ? "http" : "https"
            }://${magnetoApiEndpoint}`,
            region,
            credentials: { accessKeyId, secretAccessKey, sessionToken },
        });
    } catch (e: unknown) {
        console.error("mangeto api instantiation error", e);
        if (e instanceof Error) {
            throw new Error(e.message);
        }
        // Handle other error types or rethrow
        throw new Error("An unknown error occurred");
    }
}

export function useMagnetoApi(): AdsMagnetoIHubClient | null {
    const [client, getMagnetoClient] = useStore(apiClientsStore, (state) => [
        state.magneto.client,
        state.getMagnetoClient,
    ]);

    // Auto-fetch client if not available
    if (!client) {
        void getMagnetoClient();
    }

    return client;
}
